<!-- T043: Container template structure with backdrop, panel, close button -->

@if (config()?.hasBackdrop) {
  <div
    class="hx-dialog-backdrop"
    [ngStyle]="
      config()?.overlayTransparency !== undefined
        ? {
            backgroundColor: 'rgba(16, 24, 40, ' + config()?.overlayTransparency + ')',
          }
        : {}
    "
    (click)="onBackdropClick($event)"></div>
} @else {
  @if (!config()?.allowBackgroundClickWhenNoBackdrop) {
    <!-- Overlay a transparent, pointer-blocking layer to prevent background interaction -->
    <div
      class="hx-dialog-backdrop hx-dialog-backdrop--transparent"
      style="background: transparent; pointer-events: auto"
      (click)="onBackdropClick($event)"></div>
  }
}

<div
  cdkTrapFocus
  tabindex="-1"
  class="hx-dialog-panel"
  [cdkTrapFocusAutoCapture]="config()?.autoFocus === 'first-element'"
  [class.hx-dialog-panel--custom-dimensions]="hasCustomDimensions()"
  [class.hx-dialog-panel--fullscreen]="config()?.size === 'fullscreen'"
  [class.hx-dialog-panel--large]="config()?.size === 'large'"
  [class.hx-dialog-panel--medium]="config()?.size === 'medium'"
  [class.hx-dialog-panel--position-bottom]="config()?.position === 'bottom'"
  [class.hx-dialog-panel--position-center]="config()?.position === 'center'"
  [class.hx-dialog-panel--position-left]="config()?.position === 'left'"
  [class.hx-dialog-panel--position-right]="config()?.position === 'right'"
  [class.hx-dialog-panel--position-top]="config()?.position === 'top'"
  [class.hx-dialog-panel--small]="config()?.size === 'small'"
  [class.hx-dialog-panel--xlarge]="config()?.size === 'xlarge'"
  [style.height]="config()?.height"
  [style.max-height]="config()?.maxHeight"
  [style.max-width]="config()?.maxWidth"
  [style.min-height]="config()?.minHeight"
  [style.min-width]="config()?.minWidth"
  [style.width]="config()?.width">
  <!-- T044: Close button with icon -->

  @if (!config()?.disableClose) {
    <button aria-label="Close" class="hx-dialog-close-btn" type="button" (click)="onCloseClick()">
      <svg
        class="hx-dialog-close-icon"
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15 5L5 15M5 5L15 15"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2" />
      </svg>
    </button>
  }

  <!-- T045: Content projection slot for dialog content -->
  <div class="hx-dialog-content">
    <ng-template cdkPortalOutlet />
  </div>
</div>
